var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-touch',{staticClass:"switch-button-control",on:{"swipeleft":_vm.toggle,"swiperight":_vm.toggle}},[_c('div',{staticClass:"switch-button",class:{ enabled: _vm.isEnabled, new: _vm.isNewDesign },on:{"click":_vm.toggle}},[_c('div',{staticClass:"button-bullet"})]),_vm._v(" "),_c('div',{staticClass:"switch-button-label"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ca2af2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/switch-button/SwitchButton.vue
// module id = kUK0
// module chunks = 0 1 3 4 5